<template>
<div class='vitae'>
    <div class='container col-md-8 col-md-offset-2'></div>
    <div class='container fadeIn col-md-8 col-md-offset-2 cv'>
        <hr>
        <p><strong>EXPERIENCE:</strong></p>
         <div id='RaleighBIManager' class='resume-heading'>
            <a href='https://www.raleighnc.gov'>City of Raleigh, North Carolina</a>
            <span class='year'>January 2022 - Present</span><br />
            Manager of Business Intelligence and Data Analytics
            </div>
            <div class="resume-body">
            Manage the delivery of data analytics and business intelligence solutions to 4,000 users across 14 city-wide departments. Curate OpenData Raleigh, the city’s public data repository, to develop, release, and maintain data repositories of public interest. Supervise three direct reports conducting data engineering, data analysis, and Power Platform development.    
            <ul>
                <li>Architect and lead development efforts to construct the City of Raleigh Enterprise Data Warehouse, integrating ERP and CRM data with other key operational systems related to asset management and permitting.  Develop data pipelines using CData Sync, SQL Server, SSIS, T-SQL, PowerShell, and Python. </li>
                <li>Lead the Power BI Community of Practice, an internal user group of 55 data analysts across the city, providing education and support for Power BI, DAX, SQL, and other analytics-related topics while fostering a group of peer-based support. Construct Power BI Datasets as SSAS Tabular models for citywide use. Develop reports, visualizations, and statistical models in Power BI Desktop and Python for Human Resources, Finance, and City Council.</li>
                <li>Introduced Scrum and Kanban practices to team development activities. Coach and mentor staff on dimensional data modeling, SQL, Python, PowerShell development. </li>
            </ul>
        </div>
        <div id='BrightlyMgr' class='resume-heading'>
            <a href='https://www.brightlysoftware.com/'>Brightly Software (f/k/a Dude Solutions, Inc.)</a>
            <span class='year'>April 2021 - October 2021</span><br />
            IT Manager - Enterprise Business Systems
         </div>
         <div class="resume-body">
         Managed the delivery of enterprise business system functionality to approximately 500 sales, professional support, 
         and finance personnel in five global locations. Supervised four direct reports in US and India conducting support and development activities.   
         <p></p>
         <ul>
            <li>Oversaw development activities related to the corporate Enterprise Data Warehouse, integrating data from SalesForce, Sage Intacct, and Marketo with SQL and CData pipelines for consumption by business unit data analysts.  Introduced DevOps practices to the Enterprise Business Systems group, including the use of Python, C#, and NET Core for automation.</li>
            <li>Led a corporate-wide project to integrate key business data and operational processes for an acquired entity in Australia. Coordinated with sales, professional services, and finance on planning and development of business system enhancements to support new operational processes. Working with a data integration vendor, oversaw the integration of critical customer and financial data into SalesForce and Sage Intacct. </li>
            <li>Directed efforts to improve service desk functionality by starting a team in India, developing a formal onboarding strategy, and coordinating ongoing cross-training and performance improvement efforts. Expanded the creation of support documentation and documented processes for critical incident response. Collected and reported on KPIs for continuous improvement efforts.</li>
         </ul>
         </div>
         <div id='FCBTechLead' class='resume-heading'>
            <a href='http://www.firstcitizens.com'>First Citizens Bank</a>
            <span class='year'>November 2018-April 2021</span><br />
            Technical Lead - Central Banking Operations Systems
         </div>
         <div class='resume-body'>
            Oversee the technical architecture, systems development, and implementation strategy of a complete replacement of legacy on-premise item processing systems used within the bank’s back-office.
            <p></p>
            <ul>
                <li>Oversee the technical architecture, systems development, and implementation strategy of a complete replacement of over 14 legacy on-premise item processing systems with an integrated SaaS solution and outsourced professional services.</li>
                <li>Coordinate the data integration of existing transaction systems with an outsourced service provider, including mobile and teller-based item capture channels and the bank’s Core Banking system. Develop strategies and approaches for the movement of over 1 million daily transaction items through perfecting and balancing to long-term archival storage.</li>
                <li>Identify and decompose development activities and develop estimates of effort and resources for incorporation into a multi-year project plan. Plan for the simultaneous deployment of front-counter item capture solutions at over 600 branch locations. Coordinate with QA personnel to plan the testing of development and integration customizations.</li>
                <li>Developed a set of PowerShell scripts with .NET Framework classes for use with Control-M in the manipulation of X9.100-187 files. Developed item reconciliation dashboards aggregating data from Oracle, SQL Server and DB2 in Tableau. Developed Windows Services with C# for batch processing of transaction and image data.</li>
                <li>Prepare design documentation and other artifacts and provide briefings to senior IT leadership on strategy, risk, and approach.</li>
            </ul>
        </div>

        <div id='SDManager' class='resume-heading'>
            <a href='http://www.nctreasurer.com'>North Carolina Department of State Treasurer</a>
            <span class='year'>August 2010-November 2018</span><br />
            Director of Systems Development and Support
        </div>
        <div class='resume-body'>
            Supervise the implementation, development and support of all business information systems utilized by the North Carolina Department of the State Treasurer
            <p></p>
            <ul>
                <li>Direct a team of 5 development supervisors, 24 .NET developers, and 3 MS SQL Server database developers responsible for the development and support of all business applications utilized by the Department of the State Treasurer.</li>
                <li>Lead the IT Project Management Office as Agency Portfolio Manager. Supervise the simultaneous execution of multiple projects, monitoring project manager performance, plan development, budget adherence, resource utilization, procurement and contracting, and adherence to State of NC Project Quality Management Program.</li>
                <li>Oversee the operational management of all agency business systems including:
                    <ul>
                        <li>NC ORBIT – the NC Retirement Management System, a custom VB.NET and SQL Server system with 300,000 monthly benefit recipients and $4 billion in annual benefit payments.</li>
                        <li>Core Banking – the State banking system, responsible for liquidity management, positive pay, check imaging, and disbursement of $22 billion in drawn checks annually.</li>
                        <li>UPMS – the NC Escheat Fund Management System, controlling $418 million in unclaimed property, cash and securities.</li>
                    </ul>
                </li>
                <li>Maintain the NCDST Business Application Portfolios, in conjunction with the CIO and the Director of Technical Services, to ensure alignment with strategic goals and application and technology roadmaps. </li>
                <li>Develop budget requests, cost/benefit analyses, and project justifications for review by the Office of State Budget and Management, the Department of Information Technology, and the NC General Assembly. </li>
                <li>Create biennial Departmental Information Technology Strategic Plans in conjunction with the CIO and Deputy State Treasurers to outline IT initiatives for each biennial budget cycle.</li>
                <li>Oversaw a two-year consolidation and virtualization of the business application infrastructure to achieve a 15% decrease in annual software licensing costs. </li>
                <li>Coordinated the procurement and contracting of software and professional services, including the Core Banking and Cash Management Upgrade initiative – a $4.2 million, multi-year, multi-agency project to update two critical statewide financial systems.</li>
                <li>Directed the merger of the IT systems and infrastructure of the NC Comprehensive State Health Plan, formerly an independent state agency, with the NCDST IT infrastructure.</li>
                <li>Supervised the migration of over 30 business applications to a new data center with no unplanned disruption of service.</li>
            </ul>
        </div>
        <div id='AppSupv' class='resume-heading'>
            <a href='http://www.nctreasurer.com'>North Carolina Department of State Treasurer</a>
            <span class='year'>March 2005 - August 2010</span><br />
            Application Development Project Supervisor
        </div>
        <div class='resume-body'>
            Supervised the implementation, development and support of business applications, primarily related to electronic document management and business process automation
            <ul>
                <li>Supervised a team of four business analyst/.NET developers responsible for the support and maintenance of six business-critical applications including the document repository of the NC Retirement System and the data management system of the NC Escheat Fund</li>
                <li>Directed the implementation of a $1 million electronic document management and workflow system to support operations of the Unclaimed Property Division</li>
                <li>Managed the development and implementation of an Internet-based financial analysis dashboard in conjunction with the UNC School of Government for use by citizens and local government finance officers. </li>
                <li>Developed analyses and reports for the State Treasurer, Chief of Staff, and CIO recommending improvements and strategy for IT infrastructure and systems to support business processes.</li>
                <li>Developed system enhancements utilizing C#, VB.Net and Microsoft SQL Server, SQL Server Integration Services and SQL Reporting Services and mentored development activities.</li>
            </ul>
        </div>
        <div id='DCTMConsultant' class='resume-heading'>
            Multiple Organizations
            <span class='year'>October 2003 - March 2005</span><br />
            Documentum Consultant
        </div>
        <div id='Bayer' class='resume-heading'>
            <a href='http://www.bayer.us/'>Bayer Corporation - Biological Products Division</a>
            <span class='year'>October 2002 - October 2003</span><br />
            Senior I.S. Analyst
        </div>
        <div id='FMKT' class='resume-heading'>
            <a href='https://en.wikipedia.org/wiki/SAP_Ariba'>FreeMarkets, Inc.</a>
            <span class='year'>May 2002 - October 2002</span><br />
            Documentum Consultant
        </div>
        <div id='Maryland' class='resume-heading'>
            <a href='http://dls.state.md.us/'>Maryland Dept. of Legislative Services</a>
            <span class='year'>July 1998 - April 2002</span><br />
            Senior Systems Engineer
        </div>
        <hr>
        <p><strong>EDUCATION:</strong></p>
        <div id='NCSU' class='resume-heading'>
            <a href='http://https://spia.ncsu.edu/graduate/public_administration.php'>North Carolina State University - School of Public and International Affairs</a><br />
            Master of Public Administration
        </div>
        <div id='Pitt' class='resume-heading'>
            <a href='http://sci.pitt.edu/'>University of Pittsburgh - School of Computing and Information</a><br />
            Master of Science, Information Science
        </div>
        <div id='Pitt' class='resume-heading'>
            <a href='http://www.pitt.edu/'>University of Pittsburgh</a><br />
            Bachelor of Arts, English
        </div>
        <hr>
        <p><strong>PROFESSIONAL CERTIFICATIONS:</strong></p>
        <div id='PMI' class='resume-heading'>
            <a href='https://www.pmi.org/'>Project Management Profesional (PMP)</a><br />
            Project Management Institute
        </div>
        <div id='ScrumAlliance' class='resume-heading'>
            <a href='https://www.scrumalliance.org'>Certified Scrum Master (CSM)</a><br />
            Scrum Alliance
        </div>
        <div id='UNC' class='resume-heading'>
            <a href='https://www.sog.unc.edu/courses/national-certified-government-chief-information-officer-cgcio'>Certified Government Chief Information Officer (CGCIO)</a><br />
            University of North Carolina - Chapel Hill, School of Government
        </div>
        <div id='TableauSpecialist' class="resume-heading">
            <a href="https://www.tableau.com/learn/certification/desktop-specialist">Tableau Certified Desktop Specialist</a><br/>
            Tableau Software, a SalesForce Company
        </div>
        <div id="ITIL4" class="resume-heading">
            <a href='https://www.axelos.com/certifications/itil-service-management/itil-4-foundation'>ITIL4 Foundation</a><br/>
            Axelos
        </div>
        <hr>
        <p><strong>PRESENTATIONS:</strong></p>
        <div id='NASCIO' class='resume-heading'>
            <a href='https://www.nascio.org'>All On Board: Multi-Jurisdictional Collaboration</a><br />
            National Association of State Chief Information Officers Annual Conference, Oct. 22-25, 2012
        </div>
        <div id='NCPMI' class='resume-heading'>
            <a href='https://www.ncpmi.org'>Cost-Benefit Analysis for Public Sector and Non-Profit Initiatives</a><br />
            North Carolina Project Management Institute - Public Sector CoP - Oct. 24, 2018
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'CV',
    props: {},
    beforeRouteEnter (to, from, next) {
        document.getElementsByTagName("body")[0].classList.remove("showBackground");
        document.getElementsByTagName("body")[0].classList.add("hideBackground");
        document.getElementsByTagName("body")[0].classList.remove("backgroundFadeIn");
        document.getElementsByTagName("body")[0].classList.add("backgroundFadeOut");
        next();
    },
}
</script>

<style>
.cv {
    font-family: 'Roboto', sans-serif;
    background-color: #D6D6D6;
    color: #000000;
    padding-bottom: 2em;
}

ul.noBullets {
    margin: 0;
    padding: 0;
}

ul.noBullets li {
    letter-spacing: 1em;
    line-height: 2em;
    list-style-type: none;
}

#ResumeHeader {
    text-align: center;
}

.year {
    float: right;
}

.cv li {
    padding: .2em;
}

.cv a:link {
    color: #424242;
}

.cv a:visited {
    color: #FFFFFF;
}

.resume-heading {
    background-color: #D6D6D6;
    background-position: center;
    background-repeat: no-repeat;
    background-blend-mode: overlay;
    background-size: contain;
}

#RaleighBIManager {
    background-image: url('../assets/images/ResumeImages/raleigh.png');
}

#BrightlyMgr {
    background-image: url('../assets/images/ResumeImages/brightly.png');
}

#SDManager,
#AppSupv {
    background-image: url('../assets/images/ResumeImages/ncsealb&w.png');
}

#DCTMConsultant {
    background-image: url('../assets/images/ResumeImages/documentumbw.png');
}

#Bayer {
    background-image: url('../assets/images/ResumeImages/bayer.png');
}

#FMKT {
    background-image: url('../assets/images/ResumeImages/freemarkets.png');
}

#Maryland {
    background-image: url('../assets/images/ResumeImages/marylandseal.png');
}

#NCSU {
    background-image: url('../assets/images/ResumeImages/ncsu.png');
}

#Pitt {
    background-image: url('../assets/images/ResumeImages/pitt.png');
}

#PMI {
    background-image: url('../assets/images/ResumeImages/pmi.png');
}

#ScrumAlliance {
    background-image: url('../assets/images/ResumeImages/scrum.png');
}

#UNC {
    background-image: url('../assets/images/ResumeImages/UNC.png');
}

#NASCIO {
    background-image: url('../assets/images/ResumeImages/NASCIO.png');
}

#NCPMI {
    background-image: url('../assets/images/ResumeImages/ncpmi.png');
}

#ITIL4 {
    background-image: url('../assets/images/ResumeImages/ITIL4.png');
}

#FCBTechLead{
    background-image: url('../assets/images/ResumeImages/logo_fcb.png');
}
.resume-heading {
    font-size: 1.1em;
    margin-top: 1.2em;
}

.resume-body {
    padding-top: .5em;
}

</style>
